import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full"
}
const _hoisted_2 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_SelectUserForUserSubscription = _resolveComponent("SelectUserForUserSubscription")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_setting_card = _resolveComponent("setting-card")!

  return (_ctx.config)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_setting_card, _mergeProps(_ctx.binds, {
          hideMoreVert: true,
          hidePrevious: _ctx.hidePrevious,
          hideValid: _ctx.currentStep !== 'declaration_setting' ? true : false,
          onUpdateProfile: _cache[22] || (_cache[22] = ($event: any) => (_ctx.updateProfile())),
          onPrevious: _ctx.actions.previous,
          onClose: _cache[23] || (_cache[23] = ($event: any) => (_ctx.currentStep = 'declaration_setting'))
        }), {
          default: _withCtx(() => [
            _createVNode(_component_v_window, {
              modelValue: _ctx.currentStep,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.currentStep) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_window_item, {
                  value: "declaration_setting",
                  style: {"width":"50vw"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "d-flex justify-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "8",
                          class: "pb-2 pt-6 text-h6 pl-3"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("settingDeclaration.codes-ROF")), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "8" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, {
                              "no-gutters": "",
                              class: "rounded-xl px-2 border-thin"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.rofs, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_v_col, {
                                    cols: "12",
                                    key: index + 1
                                  }, {
                                    default: _withCtx(() => [
                                      (index && index < _ctx.config.rofs.length - 1)
                                        ? (_openBlock(), _createBlock(_component_v_divider, { key: 0 }))
                                        : _createCommentVNode("", true),
                                      (item.prefix !== 'ISGROUPE')
                                        ? (_openBlock(), _createBlock(_component_v_row, {
                                            key: 1,
                                            "no-gutters": ""
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(), _createBlock(_component_v_col, {
                                                cols: "7",
                                                class: "d-flex align-center",
                                                key: index + 2,
                                                style: {"height":"62px"}
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.translateTaxName(item.tax)), 1)
                                                ]),
                                                _: 2
                                              }, 1024)),
                                              (_openBlock(), _createBlock(_component_v_col, {
                                                cols: "5",
                                                class: "d-flex justify-end align-center",
                                                key: index + 3,
                                                style: {"height":"62px"}
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_text_field_filled, {
                                                    modelValue: item.code,
                                                    "onUpdate:modelValue": ($event: any) => ((item.code) = $event),
                                                    "hide-details": "",
                                                    outlined: "",
                                                    prefix: item.prefix,
                                                    density: "compact"
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "prefix"])
                                                ]),
                                                _: 2
                                              }, 1024))
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : (_ctx.incomeCategory !== 'BNC')
                                          ? (_openBlock(), _createBlock(_component_v_row, {
                                              key: 2,
                                              "no-gutters": ""
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(), _createBlock(_component_v_col, {
                                                  cols: "7",
                                                  class: "d-flex align-center",
                                                  key: index + 4,
                                                  style: {"height":"62px"}
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.translateTaxName(item.tax)) + " ", 1),
                                                    _createVNode(_component_v_spacer),
                                                    _createVNode(_component_v_switch, {
                                                      modelValue: _ctx.config.taxIntegration,
                                                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.config.taxIntegration) = $event)),
                                                      "hide-details": "",
                                                      class: "mt-0 pt-0"
                                                    }, null, 8, ["modelValue"]),
                                                    _createVNode(_component_v_spacer)
                                                  ]),
                                                  _: 2
                                                }, 1024)),
                                                (_openBlock(), _createBlock(_component_v_col, {
                                                  cols: "5",
                                                  class: "d-flex justify-end align-center",
                                                  key: index + 5,
                                                  style: {"height":"62px"}
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_ctx.config.taxIntegration)
                                                      ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                                                          key: 0,
                                                          modelValue: item.code,
                                                          "onUpdate:modelValue": ($event: any) => ((item.code) = $event),
                                                          "hide-details": "",
                                                          outlined: "",
                                                          prefix: item.prefix,
                                                          density: "compact"
                                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "prefix"]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "8",
                          class: "pb-2 pt-6 text-h6 pl-3"
                        }, {
                          default: _withCtx(() => _cache[24] || (_cache[24] = [
                            _createTextVNode(" OGA ")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "8" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, {
                              "no-gutters": "",
                              class: "rounded-xl px-2 border-thin"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "d-flex align-center",
                                  style: {"height":"62px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("settingDeclaration.adhesion-OGA")) + "; ", 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "d-flex justify-end align-center",
                                  style: {"height":"62px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_switch, {
                                      modelValue: _ctx.config.ogaEnrolment,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.config.ogaEnrolment) = $event)),
                                      "hide-details": "",
                                      class: "mt-0 pt-0"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                (_ctx.config.ogaEnrolment)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_divider),
                                          _createVNode(_component_v_row, {
                                            "no-gutters": "",
                                            style: {"height":"62px"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, {
                                                cols: "6",
                                                class: "d-flex align-center pr-1"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_text_field_filled, {
                                                    modelValue: _ctx.config.ogaEnrolmentConfig.numberId,
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.config.ogaEnrolmentConfig.numberId) = $event)),
                                                    "hide-details": "",
                                                    label: 
                                                        _ctx.$t(
                                                            'settingDeclaration.numero-identification',
                                                        )
                                                    ,
                                                    outlined: "",
                                                    density: "compact"
                                                  }, null, 8, ["modelValue", "label"])
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, {
                                                cols: "6",
                                                class: "d-flex align-center pl-1"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_text_field_filled, {
                                                    modelValue: _ctx.config.ogaEnrolmentConfig.year,
                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.config.ogaEnrolmentConfig.year) = $event)),
                                                    "hide-details": "",
                                                    label: _ctx.$t('settingDeclaration.annee'),
                                                    outlined: "",
                                                    density: "compact"
                                                  }, null, 8, ["modelValue", "label"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_divider),
                                          _createVNode(_component_v_text_field_filled, {
                                            modelValue: _ctx.config.ogaEnrolmentConfig.siret,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.config.ogaEnrolmentConfig.siret) = $event)),
                                            "hide-details": "",
                                            label: _ctx.$t('settingDeclaration.SIRET'),
                                            outlined: "",
                                            class: "my-2",
                                            density: "compact"
                                          }, null, 8, ["modelValue", "label"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_divider),
                                          _createVNode(_component_v_text_field_filled, {
                                            modelValue: _ctx.config.ogaEnrolmentConfig.designation,
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.config.ogaEnrolmentConfig.designation) = $event)),
                                            "hide-details": "",
                                            label: _ctx.$t('settingDeclaration.designation'),
                                            outlined: "",
                                            class: "my-2",
                                            density: "compact"
                                          }, null, 8, ["modelValue", "label"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_divider),
                                          _createVNode(_component_v_text_field_filled, {
                                            modelValue: _ctx.config.ogaEnrolmentConfig.address,
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.config.ogaEnrolmentConfig.address) = $event)),
                                            "hide-details": "",
                                            label: _ctx.$t('settingDeclaration.addresse'),
                                            outlined: "",
                                            class: "my-2",
                                            density: "compact"
                                          }, null, 8, ["modelValue", "label"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_divider),
                                          _createVNode(_component_v_row, {
                                            "no-gutters": "",
                                            style: {"height":"62px"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, {
                                                cols: "6",
                                                class: "d-flex align-center pr-1"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_text_field_filled, {
                                                    modelValue: _ctx.config.ogaEnrolmentConfig.postalCode,
                                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.config.ogaEnrolmentConfig.postalCode) = $event)),
                                                    "hide-details": "",
                                                    label: _ctx.$t('settingDeclaration.code-postal'),
                                                    outlined: "",
                                                    density: "compact"
                                                  }, null, 8, ["modelValue", "label"])
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, {
                                                cols: "6",
                                                class: "d-flex align-center pl-1"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_text_field_filled, {
                                                    modelValue: _ctx.config.ogaEnrolmentConfig.city,
                                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.config.ogaEnrolmentConfig.city) = $event)),
                                                    "hide-details": "",
                                                    label: _ctx.$t('settingDeclaration.ville'),
                                                    outlined: "",
                                                    density: "compact"
                                                  }, null, 8, ["modelValue", "label"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "8",
                          class: "pb-2 pt-6 text-h6 pl-3"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("settingDeclaration.paiement")) + " ", 1),
                            _createVNode(_component_v_btn_icon, {
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.dialogInfoVatBankAccount = true)),
                              icon: "$oss-help"
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "8" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, {
                              "no-gutters": "",
                              class: "rounded-xl border-thin px-2",
                              style: {"height":"62px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("settingDeclaration.compte-bancaire-telepay")), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { class: "d-flex justify-end align-center" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select_filled, {
                                      modelValue: _ctx.config.vatBankAccount.id,
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.config.vatBankAccount.id) = $event)),
                                      items: _ctx.bankAccounts,
                                      rules: _ctx.bankAccountSelectHint,
                                      "item-value": "id",
                                      rounded: "",
                                      outlined: "",
                                      "hide-details": "auto",
                                      density: "compact",
                                      "item-title": (item) => item.name
                                    }, null, 8, ["modelValue", "items", "rules", "item-title"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "8",
                          class: "pb-2 pt-6 text-h6 pl-3"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("settingDeclaration.souscription-mail-EDI")), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "8",
                          class: "pb-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, {
                              "no-gutters": "",
                              class: "rounded-xl border-thin px-2",
                              style: {"height":"62px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "d-flex align-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("settingDeclaration.souscription-mail-tva")), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "d-flex justify-end align-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.currentStep = 'select_user_tva'))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("settingDeclaration.modifier-les-inscrits")), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "8",
                          class: "pb-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, {
                              "no-gutters": "",
                              class: "rounded-xl border-thin px-2",
                              style: {"height":"62px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "d-flex align-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("settingDeclaration.souscription-mail-IS")), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "d-flex justify-end align-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.currentStep = 'select_user_is'))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("settingDeclaration.modifier-les-inscrits")), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "8",
                          class: "pb-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, {
                              "no-gutters": "",
                              class: "rounded-xl border-thin px-2",
                              style: {"height":"62px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "d-flex align-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("settingDeclaration.souscription-mail-CVAE")), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "d-flex justify-end align-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.currentStep = 'select_user_cvae'))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("settingDeclaration.modifier-les-inscrits")), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.dialogInfoVatBankAccount)
                      ? (_openBlock(), _createBlock(_component_oss_dialog, {
                          key: 0,
                          modelValue: _ctx.dialogInfoVatBankAccount,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.dialogInfoVatBankAccount) = $event)),
                          title: "$t('settingDeclaration.information')",
                          onValid: _cache[15] || (_cache[15] = ($event: any) => (_ctx.dialogInfoVatBankAccount = false)),
                          onClose: _cache[16] || (_cache[16] = ($event: any) => (_ctx.dialogInfoVatBankAccount = false)),
                          width: "600px"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_2, [
                              _createElementVNode("h4", null, _toDisplayString(_ctx.$t("settingDeclaration.dialog-header")), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, {
                  value: "select_user_tva",
                  style: {"width":"45vw"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectUserForUserSubscription, {
                      companyId: _ctx.companyId,
                      mailToSubscribe: "EDI_TVA",
                      isBack: true,
                      actions: _ctx.actions,
                      onPrevious: _cache[17] || (_cache[17] = ($event: any) => (_ctx.currentStep = 'declaration_setting'))
                    }, null, 8, ["companyId", "actions"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, {
                  value: "select_user_liasse",
                  style: {"width":"45vw"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectUserForUserSubscription, {
                      companyId: _ctx.companyId,
                      mailToSubscribe: "EDI_LIASSE",
                      isBack: true,
                      actions: _ctx.actions,
                      onPrevious: _cache[18] || (_cache[18] = ($event: any) => (_ctx.currentStep = 'declaration_setting'))
                    }, null, 8, ["companyId", "actions"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, {
                  value: "select_user_is",
                  style: {"width":"45vw"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectUserForUserSubscription, {
                      companyId: _ctx.companyId,
                      mailToSubscribe: "EDI_IS",
                      isBack: true,
                      actions: _ctx.actions,
                      onPrevious: _cache[19] || (_cache[19] = ($event: any) => (_ctx.currentStep = 'declaration_setting'))
                    }, null, 8, ["companyId", "actions"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, {
                  value: "select_user_cvae",
                  style: {"width":"45vw"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectUserForUserSubscription, {
                      companyId: _ctx.companyId,
                      mailToSubscribe: "EDI_CVAE",
                      isBack: true,
                      actions: _ctx.actions,
                      onPrevious: _cache[20] || (_cache[20] = ($event: any) => (_ctx.currentStep = 'declaration_setting'))
                    }, null, 8, ["companyId", "actions"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 16, ["hidePrevious", "hideValid", "onPrevious"])
      ]))
    : _createCommentVNode("", true)
}